(function ($) {
    'use strict';

    $('.ct-image-carousel .ct-image-carousel__list').slick({
        arrows: true,
        appendArrows: '.ct-image-carousel__arrows',
        dots: true,
        dotsClass: 'ct-image-carousel__dots',
        infinite: true,
        focusOnSelect: true,
        focusOnChange: true,
        slidesToShow: 1,
        customPaging: function () {
            //Removes each one and moves it in the DOM as its processed so we always want index 0
            return $('.ct-image-carousel__control')[0];
        }
    });

}(jQuery));